import axios from 'axios';
// import Qs from 'qs';
let Qs = require('qs');
import getCookie from './cookie';

// 导出静态方法
const all = axios.all;
const spread = axios.spread;

const request = axios.create({
  // 超时时间
  // timeout: 20000,
  // 返回值类型
  responseType: 'json',
  headers: {
    token: getCookie('_token'),
  },
  paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'brackets' }),
  // 允许携带cookie
  withCredentials: true,
});

// 请求拦截
request.interceptors.request.use(
  config => {
    if(config.method === 'post') {
      // let data = Qs.parse(config.data)

      // config.data = Qs.stringify({
      //   // appId: 100178,
      //   // _t,
      //   platform:'PC',
      //   // token:md5(100178+'j2n5lbZdEolIDoLO'+_t),
      //   // guid:'',
      //     ...data
      // })
  } else if(config.method === 'get') {
      // config.params = {
      //   // appId: 100178,
      //   // _t:(new Date()).getTime(),
      //   platform:'PC',
      //   // token:md5(100178+'j2n5lbZdEolIDoLO'+_t),
      //   // guid:'',
      //   ...config.params
      // }
  }
    return config;
  },
  err => Promise.reject(err)
);

// 响应拦截
request.interceptors.response.use(
  res => {
    // if (res.data && res.data.code === 99998) {
    //   // 验证失败，需要重新登陆
    //   message.error(res.data.message);
    //   // 跳转到登陆系统进行登陆
    //   window.location.href = `${res.data.data.login_url}/?call_back=${encodeURIComponent(
    //     window.location.href
    //   )}`;
    // }
    // 获取到数据处理
    if (res.data && (res.data.state === 200 || res.data.state === true || res.data.code === 200)) {
      return res.data;
    }
    if (res.data && res.data.code === 10000) {
      return res.data;
    }
    // 错误统一处理
    // if (res.data && res.data.state == 400) {
    //   message.error(res.data.message);
    //   return res.data;
    // }
    if (res.data && res.data.state !== 200 && res.data.state !== true) {
      // let msgNode = document.querySelectorAll('.ant-message');
      // //console.log(msgNode);
      // if(!msgNode.length){
      //message.error(res.data.message);
      //   setTimeout(function() {
      //     message.destroy();
      //   },5000)
      // }
      // message.destroy();
      // message.error(res.data.message);
      return res.data;
    }
    // http异常
    if (res.status !== 200) {
      const msgNode = document.querySelectorAll('.ant-message');
      if (!msgNode.length) {

      }
    }
  },
  err => {
    if (err.response && err.response.status >= 400) {
      const msgNode = document.querySelectorAll('.ant-message');
      if (!msgNode.length) {

      }
    }
    Promise.reject(err);
  },
);

export { all, spread };
export default request;
